<ul class="flex flex-wrap space-x-2.5 md:space-x-2">
    <li *ngFor="let tab of tabs" (click)="selectTab(tab)" class="md:px-0 md:h-16 w-fit" [class.active]="tab.active">
      <button class="w-full h-full flex items-center justify-center px-3.5 py-2 md:py-0 md:px-4 text-base rounded-3xl md:rounded-t-2xl md:rounded-b-none space-x-2" [ngClass]="{'bg-primary text-white md:bg-white md:text-primary font-medium': tab.active, 'bg-[#0357ee]/5 md:bg-[#0357ee]/5 text-darkblue/70 font-medium': !tab.active}">
        <span class="font-medium">{{tab.title}}</span>
        <span *ngIf="tab.suffix && tab.isStringSuffix()" class="text-white text-[11px] leading-none py-[3px] px-2 md:px-1.5 rounded-md md:rounded" [ngClass]="{'bg-darkblue md:bg-primary': tab.active, 'bg-darkblue/70': !tab.active}">{{tab.suffix}}</span>
        <div *ngIf="tab.suffixTemplate">
            <ng-container [ngTemplateOutlet]="tab.suffixTemplate">
            </ng-container>
        </div>
      </button>
    </li>
</ul>
<ng-content></ng-content>